@if (currentView === SETTINGS_VIEW) {
  <div class="title">
    {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.TITLE' | translate }}
  </div>
  <div class="subtitle">
    {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.PROMPT' | translate }}
  </div>
}

<div class="settings">
  <form *ngIf="!loadingAvailabilityForm; else loadingForm" [formGroup]="form" (ngSubmit)="setAvailability()">
    <div class="week">
      <mat-card
        appearance="outlined"
        *ngFor="let day of daysOfWeek; let i = index; let first = first"
        class="weekday"
        [style.margin-left.px]="first ? 0 : -1"
      >
        <mat-card-title class="weekday-title">
          <mat-checkbox [checked]="isDayEnabled(day)" (change)="setIsDayEnabled(day, $event.checked)"> </mat-checkbox>
          <div>
            {{ indexToDayOfWeekMapping[i].name }}
          </div>
        </mat-card-title>
        <mat-card-content class="weekday-content" (click)="openEditAvailabilityDialog(day)">
          <div *ngIf="isDayEnabled(day)" class="weekday-ranges">
            <a *ngFor="let range of rangesForDay(day)">
              {{ range.start | date: 'h:mma' | lowercase }}–&#10; {{ range.end | date: 'h:mma' | lowercase }}
            </a>
          </div>
          <div *ngIf="!isDayEnabled(day) || rangesForDay(day).length === 0" class="unavailable">
            {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.UNAVAILABLE' | translate }}
          </div>
        </mat-card-content>
      </mat-card>
    </div>
    <div class="timezone-selector" *ngIf="currentView === SETTINGS_VIEW">
      <glxy-timezone-selector
        [initialTimezone]="timezone"
        [control]="form.controls['timezone']"
      ></glxy-timezone-selector>
    </div>
  </form>
  <glxy-error *ngIf="shouldShowSlotSelectionErrorValue">
    {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.MANDATORY' | translate }}
  </glxy-error>
  <glxy-error *ngIf="shouldShowSlotAvailabilityErrorValue">
    {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.NO_AVAILABILITY' | translate }}
  </glxy-error>
  <glxy-error *ngIf="displayAvailabilityInsufficientDurationError">
    {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.MIN_DURATION' | translate: { duration: meetingDuration } }}
  </glxy-error>
  <glxy-error *ngIf="currentView === SETTINGS_VIEW && !isAvailabilitySet">
    {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.ALERTS.AVAILABILITY_TIME_REQUIRED_ERROR' | translate }}
  </glxy-error>
</div>

<ng-template #loadingForm>
  <div class="form-row fields-row day-container">
    <div class="shimmer-box stencil-shimmer"></div>
    <div class="shimmer-box stencil-shimmer"></div>
    <div class="shimmer-box stencil-shimmer"></div>
    <div class="shimmer-box stencil-shimmer"></div>
    <div class="shimmer-box stencil-shimmer"></div>
    <div class="shimmer-box stencil-shimmer"></div>
    <div class="shimmer-box stencil-shimmer"></div>
  </div>
  <div class="form-row fields-row shimmer-margin">
    <div class="shimmer-box stencil-shimmer time-zone-message"></div>
  </div>
  <div class="form-row form-actions shimmer-buttons">
    <button mat-raised-button color="primary" type="submit" [disabled]="true">
      {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.BUTTONS.SAVE' | translate }}
    </button>
  </div>
</ng-template>

<div class="actions" *ngIf="currentView === SETTINGS_VIEW">
  <div class="timezone-gutter"></div>
  <div class="form-row form-actions">
    <button
      *ngIf="!savingAvailabilityForm"
      mat-raised-button
      color="primary"
      type="submit"
      (click)="setAvailability()"
      [disabled]="currentView === SETTINGS_VIEW && !isAvailabilitySet"
    >
      {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.BUTTONS.SAVE' | translate }}
    </button>
    <span *ngIf="savingAvailabilityForm">
      <mat-spinner [diameter]="30" [strokeWidth]="8"></mat-spinner>
    </span>
  </div>
</div>
